import { Reveal } from "./Reveal";
import { Gauge, Target, Blocks, Sparkles } from "lucide-react";

const reasons = [
  { icon: Gauge, title: "Velocidad de ejecución", desc: "Avanzo rápido y publico pronto, sin procesos eternos ni reuniones vacías." },
  { icon: Target, title: "Enfoque en negocio", desc: "No vendo diseño bonito: vendo páginas y apps que mueven un número." },
  { icon: Blocks, title: "Soluciones a la medida", desc: "Construyo lo que tu operación necesita, no plantillas genéricas." },
  { icon: Sparkles, title: "IA como acelerador interno", desc: "Uso IA para entregar más rápido y mejor, no como promesa de marketing." },
];

export const WhyMe = () => (
  <section id="porque" data-testid="why-me" className="relative z-10 py-24 sm:py-32">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="grid lg:grid-cols-12 gap-12 items-start">
        <Reveal className="lg:col-span-5">
          <p className="overline mb-3">Por qué trabajar conmigo</p>
          <h2 className="font-display font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-[1.05]">
            Un estudio serio que resuelve negocio
          </h2>
          <p className="mt-6 text-zinc-400 leading-relaxed">
            Trabajas directo conmigo, sin intermediarios. Traduzco tu objetivo en una
            solución digital concreta y la ejecuto con criterio y velocidad.
          </p>
        </Reveal>

        <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4">
          {reasons.map((r, i) => (
            <Reveal key={r.title} delay={i * 0.08}>
              <div className="glass rounded-2xl p-6 h-full hover-lift hover:border-white/25 transition-colors duration-300">
                <r.icon className="text-[var(--magenta)]" size={26} />
                <h3 className="font-display font-semibold text-lg mt-4">{r.title}</h3>
                <p className="mt-2 text-sm text-zinc-400 leading-relaxed">{r.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
